export const animationDurationMs = 320;
export const delayAfterReopeningMs = 100;
